import { createTypeGuard, getAssetContentMarker, getAssetEpisodeIndication, isAssetPurchasable } from '../asset';
import { Linear } from '../compat/types';

import type {
  WatchedAsset,
  WatchedEpisodeAsset,
  WatchedMovieAsset,
  WatchedProgramAsset,
  WatchedRecordingAsset,
} from './types';

export function getWatchingProgress(asset: WatchedAsset) {
  const progress = (asset.position / asset.duration) * 100;

  return Math.max(0, Math.min(progress, 100));
}

export const isWatchedProgramAsset = createTypeGuard<WatchedAsset, WatchedProgramAsset>('program');
export const isWatchedRecordingAsset = createTypeGuard<WatchedAsset, WatchedRecordingAsset>('recording');
export const isWatchedEpisodeAsset = createTypeGuard<WatchedAsset, WatchedEpisodeAsset>('episode');
export const isWatchedMovieAsset = createTypeGuard<WatchedAsset, WatchedMovieAsset>('movie');

export function getWatchedAssetContentMarker(asset: WatchedEpisodeAsset | WatchedMovieAsset) {
  return getAssetContentMarker(asset);
}

export function getWatchedAssetEpisodeIndication(
  asset: WatchedEpisodeAsset | WatchedProgramAsset | WatchedRecordingAsset,
) {
  return getAssetEpisodeIndication(asset);
}

export function getWatchedAssetTitle(asset: WatchedAsset) {
  const hasSeriesId =
    (isWatchedEpisodeAsset(asset) || isWatchedProgramAsset(asset) || isWatchedRecordingAsset(asset)) &&
    Boolean(asset.seriesId);

  if (hasSeriesId) {
    return asset.seriesName ?? asset.title;
  }

  return asset.title;
}

export function isWatchedAssetPurchasable(asset: WatchedAsset, channels: Map<number, Linear>) {
  if (isWatchedProgramAsset(asset) || isWatchedRecordingAsset(asset)) {
    return !channels.get(asset.channelId)?.linearEntitlement;
  }

  if (isWatchedEpisodeAsset(asset) || isWatchedMovieAsset(asset)) {
    return isAssetPurchasable(asset);
  }

  return false;
}
